import { render, staticRenderFns } from "./EmailInteraction.vue?vue&type=template&id=29fa2803&scoped=true&"
import script from "./EmailInteraction.vue?vue&type=script&lang=js&"
export * from "./EmailInteraction.vue?vue&type=script&lang=js&"
import style0 from "./EmailInteraction.vue?vue&type=style&index=0&id=29fa2803&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fa2803",
  null
  
)

export default component.exports